export class Loader {
    private display: boolean;

    show() {
        this.display = true;
    }

    hide() {
        this.display = false;
    }

    isActive() {
        return this.display;
    }
}
